import React from 'react'

export default function ClassOptions({
  defaultClassName,
  selectedClass,
  classes,
  onChangeFundClass,
}) {
  const onChangeFundClassDropdown = (event) => {
    onChangeFundClass(event)
  }

  return (
    <div className="u-lg-flex u-lg-flexAlignItemsCenter u-sm-marginBottom5gu">
      <label className="Form-label u-marginBottom0" htmlFor="class_dropdown">
        Class
      </label>
      <div className="Dropdown u-sm-marginLeft0 u-md-marginLeft0 u-marginLeft2gu">
        <select
          id="class_dropdown"
          value={(selectedClass && selectedClass.className) || defaultClassName}
          className="Dropdown-menu"
          data-qa-automation={'classDropdown'}
          onChange={onChangeFundClassDropdown}
        >
          {classes && classes.length > 0
            ? classes.map((fundClass) => {
                return (
                  <option key={fundClass.className} value={fundClass.className}>
                    {fundClass.className}
                  </option>
                )
              })
            : null}
        </select>
      </div>
    </div>
  )
}
